import { useSelector } from "react-redux";
import TableHead from "../../../../components/UI/TableUI/TableHead";
import { STATION_REPAIRS_COLUMNS } from "../../utils/siteTables.config";
import NoDataDisplay from "../../../../components/UI/NoDataDisplay";
import { checkValue } from "../../../../functions/checkValue";
import { formatDate } from "../../../../functions/dateTime/formatDate";

export const RepairsTableView = () => {
  const sitesData = useSelector((state) => state.data.data);
  const isDataAvailable = sitesData.length > 0;
  return (
    <div className="table-container table-height scroll-area">
      <table className={`table ${!isDataAvailable ? "relative" : ""}`}>
        <tbody>
          <TableHead headList={STATION_REPAIRS_COLUMNS} />
          {isDataAvailable ? (
            <>
              {sitesData.map((s, index) => {
                return (
                  <tr className="table-row [&_td]:p-3" key={index}>
                    <td>{index+1}</td>
                    <td className="text-left">
                      <p className="w-[7rem] whitespace-normal">
                        {s.station.name}
                      </p>
                      <p className="text-xs lg:text-sm text-gray-400 font-normal">
                        SITE ID-{s.station.id}
                      </p>
                    </td>
                    <td>{checkValue(s.station.machineID)}</td>
                    <td>{formatDate(s.repairDate)}</td>
                    <td className="flex">
                      {s.workDone?.length
                        ? s.workDone.map((work) => (
                            <div
                              className="rounded bg-blue-2 text-dark-blue p-1 text-xs mx-[2px]"
                              key={work.id}
                            >
                              {work.name}
                            </div>
                          ))
                        : "-"}
                    </td>
                    <td>
                      {checkValue(
                        s.station.jbccFieldTechnician?.jbccSupervisor.fullName,
                      )}
                    </td>
                    <td>
                      {checkValue(s.station.jbccFieldTechnician?.fullName)}
                    </td>
                    <td>{checkValue(s.station.je.subDivision.name)}</td>
                  </tr>
                );
              })}
            </>
          ) : (
            <NoDataDisplay />
          )}
        </tbody>
      </table>
    </div>
  );
};
